import { useTranslation } from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import DelimiterInput from "../DelimiterInput";
import {treeActions} from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import TPCheckbox from '../TPCheckbox';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

export default function FixedLengthForm() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [recordDelimiter, setRecordDelimiter] = useState(false);
  const [trimData, setTrimData] = useState(false);
  const [decodeData, setDecodeData] = useState(false);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setRecordDelimiter(header.LINEDELIMITER || '');
    setTrimData(
      header.TRIMDATA ?
        (typeof header.TRIMDATA === 'boolean' && header.TRIMDATA) || header.TRIMDATA === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }

  return (
    <>
      <>
        <DelimiterInput
          default
          label={t('LBL_REC_DELIM_')}
          value={recordDelimiter}
          name={'LINEDELIMITER'}
        />
      </>
      {parentScreen === 'inbound' && <>
        <div className="flex flex-wrap">
          <TPCheckbox 
            label={t('BTN_TRIM_DATA')}
            checked={trimData}
            handleCheck={(checked) => {
              setTrimData(checked);
              handleChange('TRIMDATA', checked);
            }}
          />
          <TPCheckbox 
            label={t('BTN_URLDECODE_DATA')}
            checked={decodeData}
            handleCheck={(checked) => {
              setDecodeData(checked);
              handleChange('URLDECODE', checked);
            }}
          />
        </div>
        <GroupByName />
      </>
      }
    </>
  )
}
